import React, { Fragment, useState } from "react";
import { Button, Form, Row, Col, Alert, Table } from "react-bootstrap";
import { getDateFormat } from "../common";

/**
 * 개인 수행 평가 양식
 * @param {*} param0
 * @returns
 */
export const AssessmentEditStudentForm = ({
  student,
  handleSave,
  handleClose,
  handleClearQuest,
  handelEditStudent,
}) => {
  const [btnSaveDirty, setBtnSaveDirty] = useState(false);
  const [grade, setGrade] = useState(student.grade);
  const [memo, setMemo] = useState(student.memo);
  const handleGrade = (e) => {
    setBtnSaveDirty(true);
    setGrade((cur) => {
      return e.target.value;
    });
  };
  const handleMemo = (e) => {
    setBtnSaveDirty(true);
    setMemo((cur) => {
      return e.target.value;
    });
  };

  const handleClickSave = () => {
    setBtnSaveDirty(false);
    handleSave({
      grade: grade,
      memo: memo,
    });
  };

  return (
    <Fragment>
      <Row className="mt-2">
        <Col className="col-3">학번</Col>
        <Col>{student.username}</Col>
      </Row>
      <Row className="mt-2">
        <Col className="col-3">이름</Col>
        <Col>{student.displayName}</Col>
        <Col>
          <Button value={student._id} onClick={handelEditStudent}>
            진행 수정
          </Button>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="col-3">
          <Row>
            <Col>퀘스트들</Col>
          </Row>
        </Col>
        <Col>
          {student.quests.length > 0
            ? student.quests.map((it, index) => {
                return (
                  <Row key={index} className="p-1">
                    <Col>{it.buildingName}</Col>
                    <Col>
                      {it.completedAt ? (
                        getDateFormat(it.completedAt)
                      ) : (
                        <div style={{ backgroundColor: "gray" }}>미완료</div>
                      )}
                    </Col>
                    {/* <Col>
                      <Button
                        className="ms-3"
                        value={it.completedQuestId}
                        onClick={handleClearQuest}
                        disabled={!it.completedAt}
                      >
                        초기화
                      </Button>
                    </Col> */}
                  </Row>
                );
              })
            : "완료한 퀘스트가 없습니다."}
        </Col>
      </Row>
      <Row className="mt-2">
        <Form.Group controlId="dsuni-student-grade">
          <Form.Label>채점</Form.Label>
          <Form.Select value={grade} onChange={handleGrade}>
            <option value="none">none</option>
            <option value="pass">pass</option>
            <option value="failed">failed</option>
            <option value="etc">etc</option>
          </Form.Select>
        </Form.Group>
      </Row>
      <Row className="mt-2">
        <Form.Group controlId="dsuni-student-memo">
          <Form.Label>메모</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={memo}
            onChange={handleMemo}
            placeholder="메모하세요"
          >
            {memo}
          </Form.Control>
        </Form.Group>
      </Row>
      <br />
      <Button disabled={!btnSaveDirty} onClick={handleClickSave}>
        저장
      </Button>
      <Button onClick={handleClose} className="ms-3" variant="info">
        확인
      </Button>
    </Fragment>
  );
};

/**
 * 팀 수행 평가 양식
 * @param {*} param0
 * @returns
 */
export const AssessmentEditTeamForm = ({
  team,
  handleSave,
  handleClose,
  handelEditStudent,
}) => {
  const [btnSaveDirty, setBtnSaveDirty] = useState(false);
  const [grade, setGrade] = useState(team.grade);
  const [memo, setMemo] = useState(team.memo);
  const handleGrade = (e) => {
    setBtnSaveDirty(true);
    setGrade((cur) => {
      return e.target.value;
    });
  };
  const handleMemo = (e) => {
    setBtnSaveDirty(true);
    setMemo((cur) => {
      return e.target.value;
    });
  };

  const handleClickSave = () => {
    setBtnSaveDirty(false);
    handleSave({
      grade: grade,
      memo: memo,
    });
  };

  return (
    <Fragment>
      <Row className="mt-2">
        <Col className="col-3">팀</Col>
        <Col>{team.name}</Col>
      </Row>
      <br />

      {team.quests.length > 0
        ? team.quests.map((it, index) => {
            return (
              <Fragment key={index}>
                {index === 0 ? (
                  <Row>
                    <Col className="col-3">건물명</Col>
                    {it.students.map((st, sIndex) => {
                      return (
                        <Col key={sIndex}>
                          {st.userDisplayName}
                          {
                            <Button
                              className="ms-1"
                              value={st.userId}
                              onClick={handelEditStudent}
                            >
                              진행 수정
                            </Button>
                          }
                        </Col>
                      );
                    })}
                    <hr />
                  </Row>
                ) : undefined}
                <Row className="p-1">
                  <Col className="col-3">{it.buildingName}</Col>
                  {it.students.map((st, sIndex) => {
                    return (
                      <Col key={sIndex} className="me-2">
                        {st.completedAt ? (
                          getDateFormat(st.completedAt)
                        ) : (
                          <div style={{ backgroundColor: "gray" }}>미완료</div>
                        )}
                      </Col>
                    );
                  })}
                </Row>
              </Fragment>
            );
          })
        : undefined}

      <Row className="mt-2">
        <Form.Group controlId="dsuni-student-grade">
          <Form.Label>채점</Form.Label>
          <Form.Select value={grade} onChange={handleGrade}>
            <option value="none">none</option>
            <option value="pass">pass</option>
            <option value="failed">failed</option>
            <option value="etc">etc</option>
          </Form.Select>
        </Form.Group>
      </Row>
      <Row className="mt-2">
        <Form.Group controlId="dsuni-student-memo">
          <Form.Label>메모</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={memo}
            onChange={handleMemo}
            placeholder="메모하세요"
          >
            {memo}
          </Form.Control>
        </Form.Group>
      </Row>
      <br />
      <Button disabled={!btnSaveDirty} onClick={handleClickSave}>
        저장
      </Button>
      <Button onClick={handleClose} className="ms-3" variant="info">
        확인
      </Button>
    </Fragment>
  );
};
